//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    currencyName: { type: String, default: '' },
    propBuyPercent: { type: Number, deafult: undefined },
    propSellPercent: { type: Number, deafult: undefined },
    isMerchant: { type: Boolean, deafult: undefined },
    propIsEnabled: { type: Boolean, default: undefined },
  },

  data() {
    return {
      data: {
        sellProfitPercent: undefined,
        sellFeePercent: undefined,
        buyProfitPercent: undefined,
        buyFeePercent: undefined,
        isEnabled: undefined,
      },
      regex: new RegExp(/^[0-9]+([.,][0-9]+)?$/),
    };
  },

  created() {
    this.data.isEnabled = this.$props.propIsEnabled;
  },

  methods: {
    saveContent() {
      this.$emit('currency-fee-data', this.data);
    },

    saveBuyFeePercent(percent) {
      if (this.regex.test(percent)) {
        this.data.buyFeePercent = Number(percent);
        this.saveContent();
      }
    },

    saveSellFeePercent(percent) {
      if (this.regex.test(percent)) {
        this.data.sellFeePercent = Number(percent);
        this.saveContent();
      }
    },

    saveBuyProfitPercent(percent) {
      if (this.regex.test(percent)) {
        this.data.buyProfitPercent = Number(percent);
        this.saveContent();
      }
    },

    saveSellProfitPercent(percent) {
      if (this.regex.test(percent)) {
        this.data.sellProfitPercent = Number(percent);
        this.saveContent();
      }
    },

    saveIsEnabled(boolean) {
      this.data.isEnabled = boolean;
      this.saveContent();
    },
  },
};
